import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import * as AppPropTypes from '../../lib/PropTypes';

import DateLine from './DateLine';

import styles from '../../../styles/partials/event-dates.module.scss';

const propTypes = {
    item: AppPropTypes.listItem,
    className: PropTypes.string,
    itemClassName: PropTypes.string,
    dateClassName: PropTypes.string,
};

const defaultProps = {
    item: null,
    className: null,
    itemClassName: null,
    dateClassName: null,
};

const EventDates = ({ item, className, itemClassName, dateClassName }) => {
    const {
        startDate = null,
        endDate = null,
        isOnline = false,
        isPurchasable = false,
        isUpcoming = false,
    } = item || {};

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [styles.ended]: !isPurchasable,
                    [className]: className !== null,
                },
            ])}
        >
            {!isOnline ? (
                <div
                    className={classNames([
                        styles.item,
                        {
                            [itemClassName]: itemClassName !== null,
                        },
                    ])}
                >
                    <DateLine
                        className={classNames([
                            styles.date,
                            {
                                [dateClassName]: dateClassName !== null,
                            },
                        ])}
                        startDate={startDate}
                        endDate={endDate}
                        capitalize
                    />
                </div>
            ) : null}
            {isOnline && isUpcoming ? (
                <div
                    className={classNames([
                        styles.item,
                        {
                            [itemClassName]: itemClassName !== null,
                        },
                    ])}
                >
                    <FormattedMessage defaultMessage="Available from:" description="Date prefix" />{' '}
                    <DateLine
                        className={classNames([
                            styles.date,
                            {
                                [dateClassName]: dateClassName !== null,
                            },
                        ])}
                        startDate={startDate}
                    />
                </div>
            ) : null}
            {isOnline && isPurchasable && endDate !== null ? (
                <div
                    className={classNames([
                        styles.item,
                        {
                            [itemClassName]: itemClassName !== null,
                        },
                    ])}
                >
                    <FormattedMessage defaultMessage="Available until:" description="Date prefix" />{' '}
                    <DateLine
                        className={classNames([
                            styles.date,
                            {
                                [dateClassName]: dateClassName !== null,
                            },
                        ])}
                        date={endDate}
                    />
                </div>
            ) : null}
        </div>
    );
};
EventDates.propTypes = propTypes;
EventDates.defaultProps = defaultProps;

export default EventDates;
